import React, { useEffect, useState } from "react";
import InstallationView from "./InstallationView";
import crmservices from '../../wsclient';
import { httpBackOfficeUtil } from "../../wsclient/crmservices/httpBackOfficeUtil";
import { useTranslation } from "react-i18next";
import InstallationDetailView from "./InstallationDetailView";
import { sleep } from "../../utils/util";
import ConfirmComponent from "../../components/Confirm";
import UploadFile from "../../components/UploadFile";
import { getCustomFieldByKey } from "../../utils/util";
import { getData } from "../../utils/common";
import { connection } from "../../portal.config";

const MAXIUM_FILE = 3;
export default function InstallationController(props) {
	console.log("InstallationController props:", props);
	const { t } = useTranslation();
	const [showConfirm, setShowConfirm] = useState();
	const [installations, setInstallations] = useState([]);
	const [showLoadingInstallation, setShowLoadingInstallation] = useState(true);
	const [showOrderDetail, setShowOrderDetail] = useState(false);
	const [orderDetail, setOrderDetail] = useState(props.orderDetail);
	const [activities, setActivities] = useState([]);
	const [activity, setActivity] = useState(props.activity);
	const [updateActivitiesNote, setUpdateActivitiesNote] = useState();
	const [showUploadFile, setShowUploadFile] = useState(false);
	const [activityForUpload, setActivityForUpload] = useState(null);
	const [filesUpload, setFilesUpload] = useState([]);
	const [files, setFiles] = useState([]);
	const [contactAttachments, setContactAttachments] = useState([]);
	const [isLoadedAttachments, setIsLoadedAttachments] = useState(false);
	const [isReloadAttachment, setIsReloadAttachment] = useState(false);
	const [paging, setPaging] = useState({
		page: 1,
		size: 10,
		total: 0,
		has_more: false
	});

	const setShowProcessing = props.setShowProcessing;
	const showMessage = props.showMessage;
	// const activity = props.activity;
	const isSelfScheduleingUser = props.isSelfScheduleingUser;
	const [allNote, setAllNote] = useState([]);
	const [dataNoteActivity, setDataNoteActivity] = useState([]);
	const [loadMoreNote, setLoadMoreNote] = useState(false);
	const [pagingNote, setPagingNote] = useState({
		page: 1,
		size: 10,
		total: 0,
		has_more: false,
	})
	useEffect(() => {
		onLoadNoteActivity()
	}, [])
	useEffect(() => {
		if (orderDetail && orderDetail.contact && orderDetail.contact.id) {
			onLoadContactAttachments(orderDetail.contact.id);
		}
	}, [orderDetail]);

	useEffect(() => {
		if (isReloadAttachment) {
			onLoadContactAttachments(orderDetail.contact.id);
		}
	}, [isReloadAttachment]);

	useEffect(() => {
		if (isLoadedAttachments) {
			updateActivities(contactAttachments);
		}
	}, [isLoadedAttachments]);

	const updateActivities = (attachments, lstActivities) => {
		let _activities = lstActivities ? lstActivities : activities;
		_activities = _activities.map(a => {
			let custom_fields = a.custom_fields;
			let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
			if (fileCustomFields) {
				let contactFiles = attachments.filter(attm => {
					return fileCustomFields.includes(attm.file.id);
				})
				if (contactFiles && contactFiles.length > 0) {
					a.file = contactFiles[0];
				}
			}
			return a;
		})

		console.log("AAAAAA _activities:", _activities);
		setActivities(_activities);
	}

	const onLoadContactAttachments = async (contactId) => {
		let attachments = [];
		try {
			const result = await crmservices.attachments.getListAttachments({ contact_id: contactId });
			if (result.code == 'OK') {
				attachments = result.data.content ? result.data.content : [];
			}
		} catch (ex) {

		}

		setContactAttachments(attachments);
		setIsLoadedAttachments(true);
		await updateActivity(attachments)

		return attachments;
	}
	const updateActivity = (attachments) => {
		let custom_fields = activity?.custom_fields;
		let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');

		if (fileCustomFields) {
			let contactFiles = attachments.filter(attm => {
				return fileCustomFields.includes(attm.file.id);
			})

			if (contactFiles && contactFiles.length > 0) {
				setActivity(prevActivity => ({
					...prevActivity,
					files: contactFiles
				}));
			}
		}
	}

	const onLoadListInstallation = async (page, size) => {
		let data = [];
		let _paging = {
			page: 1,
			size: 10,
			total: 0
		}
		try {
			let myUserId = httpBackOfficeUtil.getSession().sub;
			var result = await crmservices.orders.getListInstallation({
				page: page ? page : paging.page,
				size: size ? size : paging.size,
				stage_id: props.stageId,
				custom_fields: `assigned_to;${myUserId}`,
				include_total: true,
			});
			if (result.code === 'OK') {
				console.log("result:", result);
				data = result.data.content ? result.data.content : [];
				_paging = result.data.paging;
				if (_paging.size < paging.size) {
					_paging.size = paging.size
				}
			}
			setInstallations(data);
			setPaging(_paging)
		} catch (error) {
			console.log("load installations error:", error);
		}
		setShowLoadingInstallation(false);
	}

	const handleChangePage = async (page) => {
		console.log("AAA page:", page);
		await onLoadListInstallation(page);
	}

	const handleChangeRowsPerPage = async (size) => {
		console.log("AAA size:", size);
		await onLoadListInstallation(1, size);
	}

	const setAddress = async (installation) => {
		let contactId = installation.contact ? installation.contact.id : null;
		try {
			const result = await crmservices.contacts.getContact(contactId);
			if (result.code == 'OK') {
				let contactAddresses = result.data.addresses;
				let primaryAddress = contactAddresses.filter(address => address.is_primary === true)[0];
				return { ...installation, contact_address: primaryAddress };
			}
		} catch (ex) {

		}
	}

	const onShowDetail = async (installation) => {
		console.log('installation:', installation);
		installation = await setAddress(installation)
		if (orderDetail && orderDetail.id == installation) {
			setShowOrderDetail(true);
			setFiles([]);
			setFilesUpload([]);
		} else {
			setIsLoadedAttachments(false);
			setShowProcessing(true);
			try {
				let isLinkedActivity = false;
				let _activities = [];
				const activityTypeId = props.activityTypeId;
				const result = await crmservices.activities.getActivities({
					type_id: activityTypeId,
					order_id: installation.id,
				})
				if (result.code == 'OK' && result.data.content && result.data.content.length > 0) {
					isLinkedActivity = true;
					_activities = result.data.content
				}
				if (isLinkedActivity) {
					const result = await crmservices.orders.getOrderDetail(installation.id);
					if (result.code == 'OK') {
						installation = { ...installation, ...result.data };
					}
					setOrderDetail(installation);
					setActivities(_activities);
					setShowOrderDetail(true);
				} else {
					showMessage({
						status: true,
						message: t('NO_ACTIVITY_FOR_ORDER'),
						title: t('ERROR'),
					});
				}
			} catch (ex) {
				console.log("onShowDetail ex:", ex);
				showMessage({
					status: true,
					message: t('EXCEPTION_PROCESS'),
					title: t('ERROR'),
				});
			}
			setShowProcessing(false);
		}
	}

	const addNote = async () => {
		try {
			for (let i = 0; i < allNote.length; i++) {
				const result = await crmservices.activities.addNoteActivity({ activity_id: activity.id, note: allNote[i] });
				if (result.code !== "OK") {
					showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
					return false;
				}
			}
			return true;
		} catch (ex) {
			console.log("addNote ex:", ex);
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') });
			return false;
		}
	};
	const onLoadNoteActivity = async () => {
		try {
			const result = await crmservices.activities.getListNoteActivity({ activity_id: activity.id });
			if (result.code == 'OK') {
				setDataNoteActivity(result.data.content)
				setPagingNote(result.data.paging);
			}
		} catch (ex) {
			console.log("onUpdateActivity ex:", ex);
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
	}
	const onLoadMoreNoteActivity = async () => {
		setLoadMoreNote(true);
		try {
			const result = await crmservices.activities.getListNoteActivity({
				activity_id: activity.id,
				page: pagingNote.page + 1,
			});
			if (result.code == 'OK') {
				let _content = dataNoteActivity.concat(result.data.content);
				setDataNoteActivity(_content)
				setPagingNote({
					...result.data.paging,
					total: pagingNote.total,
				});
			}
		} catch (ex) {
			console.log("onUpdateActivity ex:", ex);
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setLoadMoreNote(false);
	}
	const onSubmitUpdateActivity = async ({
		_act, 
		note, 
		saveButtonPressed = false, 
		scheduledDate, 
		scheduledTime, 
		scheduledTimeFrom, 
		scheduledTimeTo,
		changeScheduleDate = false,
		submitForm = false,
	}) => {
		// console.log('onUpdateActivity _act = ', _act);
		// console.log('onUpdateActivity activity = ', activity);
        // console.log('onUpdateActivity scheduledDate long value= ', (new Date(scheduledDate).getTime() / 1000));
		if (saveButtonPressed)
			setShowProcessing(true);
		
		if(scheduledTimeFrom && scheduledTimeTo && new Date(scheduledTimeFrom) >= new Date(scheduledTimeTo)){
			showMessage({ status: true, message: t('UPDATE_ACTIVITY_FROMTIME_TOTIME_INVALID') }); 
			return;
		}
				
		let payload = {
			activity_id: activity.id, state: saveButtonPressed ? undefined : "COMPLETED"
		}
		let response = {
			status: false
		}
		const fileUploaded = await onUploadFile();
		let strFileUploaded = fileUploaded && fileUploaded.length > 0 ? fileUploaded.join(",") : null;
		let custom_fields = [];
		if(_act && _act.custom_fields)
			custom_fields = _act.custom_fields;
		else if (activity.custom_fields)
			custom_fields = activity.custom_fields;

		console.log("custom_fields:", custom_fields);
		if (note) {
			custom_fields = createCustomFieldObj(custom_fields, note);
		}
		if (strFileUploaded) {
			let fileCustomFields = getCustomFieldByKey(custom_fields, 'attachments_file_id');
			if (fileCustomFields) {
				fileCustomFields = fileCustomFields + "," + strFileUploaded
			} else {
				fileCustomFields = strFileUploaded;
			}
			custom_fields.push({
				key: 'attachments_file_id',
				value: fileCustomFields
			})
		}

		console.log("custom_fields:", custom_fields);
		payload.custom_fields = custom_fields;
		console.log("payload:", payload);		
		try {
			let _scheduledTimeFrom = null;            
            if(scheduledTime && scheduledTime != 'ALL' && scheduledTimeFrom)
                _scheduledTimeFrom = (new Date(scheduledTimeFrom)).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' });
                        
            let _scheduledTimeTo = null;
            if(scheduledTime && scheduledTime != 'ALL' && scheduledTimeTo)
                _scheduledTimeTo = (new Date(scheduledTimeTo)).toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' 
			});
			const noteResult = await addNote();
			if(noteResult){
				setAllNote([])
				onLoadNoteActivity()
			}
			let isUpdateActivity = false;
			if (changeScheduleDate || submitForm) isUpdateActivity = true;
			else isUpdateActivity = false;
			if (isUpdateActivity) {
				const result = await crmservices.activities.updateActivity({ 
					custom_fields: custom_fields, 
					activity_id: activity.id, 
					state: saveButtonPressed ? undefined : "COMPLETED", 
					date: scheduledDate, 
					scheduledTimeFrom: _scheduledTimeFrom, 
					scheduledTimeTo: _scheduledTimeTo, 
				});
				if (result.code == 'OK') {
					response.status = true;
				} else {
					response.errorData = result.data;
					showMessage({ status: true, message: (result.data && result.data.message) ? result.data.message : t('UPDATE_ACTIVITY_FAIL') })
				}
			}
		} catch (ex) {
			console.log("onSubmitUpdateActivity ex:", ex);
			response.errorData = ex;
			if (saveButtonPressed) showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setShowProcessing(false);
		return response
	}

	const createCustomFieldObj = (custom_fields, newValue) => {
		let newCustomFields = custom_fields.filter(c => {
			return c.key != 'notes';
		})
		newCustomFields.push({
			key: "notes",
			value: newValue
		})

		return newCustomFields;
	}

	const onChangeNote = (event) => {
		let newActivities = activities.map(item => {
			if (activity.id == item.id) {
				item.note = event.target.value;
			}
			return item;
		})
		setActivities(newActivities);
	}
	const onCompleteActivity = (note) => async (formData) => {
		console.log("AAAAAAAAAAAAAAAAAAAAAA formData:", formData);
		setUpdateActivitiesNote(null);
		setShowProcessing(true);
		try {
			const result = await onSubmitUpdateActivity({ _act: activity, note: note, submitForm: true });
			if (result.status) {
				// props.onReloadInstallationList();
				props.onClose();
			} else {
				showMessage({ status: true, message: t('COMPLETE_ACTIVITY_FAIL') })
			}
		} catch (ex) {
			console.log("AAAAAAAAAAAAAAAAAAAAAA ex:", ex);
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setShowProcessing(false);
	}

	const onAddContactAttachment = async (file_id) => {
		let successfull = false;
		try {
			const contactId = orderDetail.contact.id;
			let result = await crmservices.attachments.addContactAttachment({
				file_id: file_id,
				contact_id: contactId
			});
			if (result.code == 'OK') {
				successfull = true;
			}
			console.log("AAAA onAddContactAttachment result: ", result)
		} catch (error) {
			console.log("onAddContactAttachment exception:", error);
		}
		return successfull;
	}

	const onCompleteAllActivity = async () => {
		console.log('onCompleteAllActivity activities:', activities);
		setUpdateActivitiesNote(null);
		setShowProcessing(true);
		try {
			let _activities = activities.filter(a => {
				return a.state == "PENDING";
			})
			let countProcess = 0;
			for (let i = 0; i < _activities.length; i++) {
				let activity = _activities[i];

				const result = await onSubmitUpdateActivity({ _act: activity, submitForm: true });
				if (!result.status) {
					setUpdateActivitiesNote({ activity_id: _activities[i].id, status: false, message: t('COMPLETE_ACTIVITY_FAIL') });
					break;
				} else {
					countProcess++;
				}
			}
			console.log('countProcess:', countProcess);
			if (countProcess == _activities.length) {
				await sleep(4000);
				await onLoadListInstallation();
				props.onReloadInstallationList();
				props.onClose();
			}
		} catch (ex) {
			showMessage({ status: true, message: t('EXCEPTION_PROCESS') })
		}
		setShowProcessing(false);
	}

	const onCompleteOrder = async () => {
		setShowProcessing(true);
		try {
			await updateOrderCustomFields();
			const result = await crmservices.orders.completeOrder(orderDetail.id);
			if (result.code == 'OK') {
				onLoadListInstallation();
				setShowProcessing(false);
				props.onClose();
				props.onReloadInstallationList();
			} else {
				showMessage({ staus: true, message: t('COMPLETE_ORDER_FAILED') })
			}
		} catch (ex) {
			showMessage({ staus: true, message: t('EXCEPTION_PROCESS') })
		}
	}

	const updateOrderCustomFields = async () => {
		try {
			let custom_fields = orderDetail.custom_fields;
			let filterCustomFields = custom_fields.filter(c => {
				return c.key != 'enable_devices'
			})
			filterCustomFields.push({
				key: 'enable_devices',
				value: 0
			})
			console.log("filterCustomFields ex:", filterCustomFields);
			await crmservices.orders.updateOrder({ custom_fields: filterCustomFields, order_id: orderDetail.id });
		} catch (ex) {
			console.log("AAAAAAA ex:", ex);
		}
	}

	const onSaveFilesState = () => {
		if (filesUpload && filesUpload.length > 0) setFiles(filesUpload);
		setShowUploadFile(false);
	}

	const uploadFiles = (files) => {
		if (files.length > MAXIUM_FILE) {
			showMessage({ status: true, message: t('error_max_files') })
			return false;
		}
		setFilesUpload(files);
	}

	const onUploadFile = async () => {
		console.log("AAAA onUploadFile files: ", files)
		let _filesUploaded = [];
		try {
			console.log("files:", files)
			if (files.length > 0) {
				for (let i = 0; i < files.length; i++) {
					console.log("files[i]:", files[i])
					const result = await crmservices.attachments.uploadFiles({ file: files[i], disalbedContentType: true });
					console.log("AAAA onUploadFile result: ", result)
					if (result.code == 'OK' && result.data.id) {
						const addContactResult = await onAddContactAttachment(result.data.id);
						if (addContactResult) {
							_filesUploaded.push(result.data.id)
						}
					}
				}
			}
		} catch (error) {
			console.log("onUploadFile exception:", error);
		}
		return _filesUploaded
	}

	const get_url_extension = (url) => {
		return url.split(/[#?]/)[0].split('.').pop().trim();
	}

	const onShowFile = async (file) => {
		setShowProcessing(true);
		try {
			let extention = get_url_extension(file.name);
			console.log("extention:", extention);
			const accessToken = getData('access_token')
			var url = connection.crmConfig.crmServer + '/backoffice/v1/files/' + file.id;
			let result = await fetch(url, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
					method: 'GET',
				}
			});
			let resultBlob = await result.blob();
			window.open(window.URL.createObjectURL(resultBlob))
		} catch (error) {
			console.log("load files service request exception:", error);
		}
		setShowProcessing(false);
	}

	const onShowUploadFile = () => {
		setShowUploadFile(true);
		// setActivityForUpload(props.activity);
	}
	return (
		<>
			<InstallationDetailView
				isOpen={props.isOpen}
				orderDetail={orderDetail}
				activity={activity}
				// activities={activities}
				updateActivitiesNote={updateActivitiesNote}
				files={files}
				onClose={props.onClose}
				onChangeNote={onChangeNote}
				onCompleteAllActivity={onCompleteAllActivity}
				onCompleteActivity={onCompleteActivity}
				onCompleteOrder={onCompleteOrder}
				setShowUploadFile={setShowUploadFile}
				onShowUploadFile={onShowUploadFile}
				onDeleteFile={props.onDeleteFile}
				onShowFile={onShowFile}
				onSave={onSubmitUpdateActivity}
				isSelfScheduleingUser={isSelfScheduleingUser}
				setAllNote={setAllNote}
				allNote={allNote}
				dataNoteActivity={dataNoteActivity}
				pagingNote={pagingNote}
				loadMoreNote={loadMoreNote}
				onLoadMoreNoteActivity={onLoadMoreNoteActivity}
			/>
			{showUploadFile && <ConfirmComponent isOpen={showUploadFile} enableCloseButton={true}
				title={'Upload File'}
				otherMessage={<UploadFile onUploadFile={uploadFiles} isMultipleFile={true} />}
				onClose={() => setShowUploadFile(false)}
				onAction={() => onSaveFilesState()}
			/>}
		</>
	)
}